

export const dayWeeks = ["", "DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB" ];
export const dayWeeksOrd = ["", "Dom", "2a", "3a", "4a", "5a", "6a", "Sáb"];
